/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface WorkflowData
 */
export interface WorkflowData {
    /**
     *
     * @type {string}
     * @memberof WorkflowData
     */
    workflowDataId?: string;
    /**
     *
     * @type {string}
     * @memberof WorkflowData
     */
    workflowId?: string;
    /**
     *
     * @type {string}
     * @memberof WorkflowData
     */
    key?: string | null;
    /**
     *
     * @type {string}
     * @memberof WorkflowData
     */
    value?: string | null;
}

export function WorkflowDataFromJSON(json: any): WorkflowData {
    return WorkflowDataFromJSONTyped(json, false);
}

export function WorkflowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'workflowDataId': !exists(json, 'workflowDataId') ? undefined : json['workflowDataId'],
        'workflowId': !exists(json, 'workflowId') ? undefined : json['workflowId'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function WorkflowDataToJSON(value?: WorkflowData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'workflowDataId': value.workflowDataId,
        'workflowId': value.workflowId,
        'key': value.key,
        'value': value.value,
    };
}

